import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: true,
})
export class SearchPipe implements PipeTransform {
    transform(
        value: any[],
        searchText: string,
        properties?: string | string[],
    ): any[] {
        if (!Array.isArray(value)) return [];
        if (!searchText) return value;

        const lowerSearch = searchText.toLowerCase();
        const searchDigits = searchText.replace(/\D+/g, '');
        const propArray = Array.isArray(properties)
            ? properties
            : properties
              ? [properties]
              : [];

        return value.filter((item: any) => {
            const haystacks = propArray.length
                ? propArray.map(p => getByPath(item, p))
                : [JSON.stringify(item)];

            return haystacks.some(val => {
                if (val == null) return false;
                const str = String(val).toLowerCase();
                if (str.includes(lowerSearch)) return true;

                if (/\d/.test(searchText)) {
                    const digits = str.replace(/\D+/g, '');
                    if (digits.includes(searchDigits)) return true;
                }
                return false;
            });
        });
    }
}

function getByPath(obj: any, path: string): any {
    return path
        .split('.')
        .reduce((o, k) => (o != null ? o[k] : undefined), obj);
}
